module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-tired.03360548.png";